exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".footer{background-color:#000;font-size:9px}.footer-logo{height:14px}.footer-link{transition:color .2 ease-in-out}.footer-link:hover{transition-timing-function:ease-out;color:#71aeff}@media screen and (min-width:30em) and (max-width:60em){.footer-logo{height:22px}}@media screen and (min-width:60em){.footer-logo{height:32px}}", ""]);

